import React from 'react';
import If from '../operator/if';

export default props => (
	<div className='box-header' style={{ minHeight: 60 }}>
		{props.children}
	</div>
);
